module.exports = __webpack_public_path__ + "img/2.a3bdb458.png";